import { ComponentProps, Fragment, forwardRef } from 'react'
import { twJoin } from 'tailwind-merge'
import { isSafari } from 'shared/utils/is-safari'

interface ScrollSafeIframeProps extends ComponentProps<'iframe'> {}

// We need to use this component because it helps solve the issue with Safari scroll. In my opinion, we should get rid of the iframe
export const ScrollSafeIframe = forwardRef<HTMLIFrameElement, ScrollSafeIframeProps>(
  function ScrollSafeIframe({ srcDoc, ...props }, ref) {
    return (
      <div className="relative w-full">
        <iframe
          ref={ref}
          className={twJoin(
            'hide-scrollbar',
            isSafari() ? `max-h-[85%] w-full overflow-y-auto` : `h-screen w-full overflow-hidden`,
          )}
          style={{
            position: 'absolute',
            opacity: 0,
            height: 0,
          }}
          data-test-id="course-lecture-iframe"
          srcDoc={srcDoc}
          {...props}
        />
      </div>
    )
  },
)
